import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocumentsByThreadId,updateFilledDataTemplateThunk } from "../../store/features/documentSlice";
import { fetchShipments } from "../../store/features/shipmentsSlice";
import DocModHeader from "../../components/Header/DocModHeader";
import ExtractedInfo from "../../components/Document/ExtractedInfo";

const DocumentModalView = ({
    isOpen,
    documentId,
    threadId,
    documentPath,
    filledDataTemplate,
    onClose,
    documentsData,
    setSelectedDocument,
  }) => {
    const dispatch = useDispatch();
    const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
    const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
    const { thread_id, case_number, documents, emailBodies} = shipment;
  
    const [selectedDocId, setSelectedDocId] = useState(documentId);
    const [selectedDoc, setSelectedDoc] = useState(
        documentsData.find((doc) => String(doc.id) === String(documentId))
    );
    const [showExtractedInfo, setShowExtractedInfo] = useState(false); // Toggle state
  

  
    // Handle document switch
    const handleDocumentSwitch = (docId) => {
      const newSelectedDoc = documentsData.find((doc) => String(doc.id) === String(docId));
      setSelectedDocId(docId);
      setSelectedDoc(newSelectedDoc);
      setSelectedDocument(newSelectedDoc);
    };
    const pdfFile = selectedDoc?.link || "";
    const extractedTemplate = selectedDoc?.ExtractedInfo || "";
  
    return (
      <div
        className={`fixed inset-0 z-50 transform ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-500`}
      >
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-black bg-opacity-50"
          onClick={onClose} // Close modal when clicking the backdrop
        ></div>

        {/* Modal Content */}
        <div
          className="absolute right-0 top-0 h-full w-[calc(87.01%)] bg-white shadow-lg"
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute rounded-full px-2 top-4 right-4 text-font-Gray hover:bg-bg-Gray text-2xl"
          >
            &times;
          </button>

          {/* Header */}
          <div className="p-4 border-b flex items-center gap-4 bg-white shadow-lg">
            <h3 className="font-bold text-lg">Document Viewer</h3>
            <select
              value={selectedDocId}
              onChange={(e) => handleDocumentSwitch(e.target.value)}
              className="border rounded p-2 text-sm"
            >
              {documentsData.map((doc) => (
                <option key={doc.id} value={doc.id}>
                  {doc.name}
                </option>
              ))}
            </select>
          </div>

          {/* Main Content */}
          <div className="flex h-[calc(82%)] border-b border-gray-300 bg-white shadow-lg">
            {/* Left Side - PDF Viewer */}
            <div
              className={`transition-all h-full duration-500 ${
                showExtractedInfo ? 'w-[60%]' : 'w-full'
              } p-2 border-r overflow-y-hidden`}
            >
              {pdfFile === "" ? (
                <div className="flex flex-col h-full items-center justify-center space-x-2">
                  <img src="/plane.gif" alt="Loading..." className="w-[30%] pb-2"/>
                  <h4>Extracting information</h4>
                </div>
              ) : (
                <iframe
                  src={pdfFile}
                  title="PDF Viewer"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              )}
            </div>

            {/* Right Side - Extracted Info */}
            {showExtractedInfo && (
              <div className="w-[40%] h-full p-2 overflow-y-auto">
                {JSON.stringify(extractedTemplate) === '{}' ? (
                  <div className="flex flex-col h-full items-center justify-center space-x-2">
                    <img src="/plane.gif" alt="Loading..." className="w-[30%] pb-2"/>
                    <h4>Extracting information</h4>
                  </div>
                ) : (
                  <ExtractedInfo
                    dataTemplate={extractedTemplate}
                    threadId={threadId}
                    documentId={selectedDocId}
                    shipmentId={threadId}
                  />
                )}
              </div>
            )}
          </div>

          {/* Toggle Button */}
          <div className="flex justify-center items-center absolute bottom-2 w-full pt-2 pb-1 pr-6 bg-white shadow-lg">
            <label className="flex items-center cursor-pointer">
              <span className="mr-4 font-semibold text-gray-600">
                {showExtractedInfo ? 'Extracted Info Shown' : 'Extracted Info Hidden'}
              </span>
              <div className="relative">
                <input
                  type="checkbox"
                  checked={showExtractedInfo}
                  onChange={() => setShowExtractedInfo(!showExtractedInfo)}
                  className="sr-only"
                  disabled={pdfFile === ""} // Disable the toggle if pdfFile is empty
                />
                <div
                  className={`block w-14 h-8 rounded-full transition-colors ${
                    showExtractedInfo ? 'bg-green-500' : 'bg-gray-300'
                  } ${
                    pdfFile === "" ? 'opacity-50 cursor-not-allowed' : '' // Add visual feedback for disabled state
                  }`}
                ></div>
                <div
                  className={`dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${
                    showExtractedInfo ? 'transform translate-x-6' : ''
                  } ${
                    pdfFile === "" ? 'opacity-50' : '' // Add visual feedback for disabled state
                  }`}
                ></div>
              </div>
            </label>
          </div>
        </div>
      </div>
    );
  };
  
  export default DocumentModalView;